import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  name: 'NAME',
  slug: 'SLUG',
  webinar_ids: 'WEBINARS COUNT',
};

function Headers({
  onChange,
  value: selectedValue,
}) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
        />
      ))}
    </tr>
  );
};

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/List/Headers.jsx